module.exports = {"en-US":{"map":{"cooperatives_list":"List of cooperatives"}}}